<template>
  <el-dialog
    :append-to-body="true"
    :title="'添加成员'"
    :visible.sync="visible"
    top="4%"
    width="960px"
    height="600px"
    id="org-group"
    :before-close="modalClose"
  >
    <div class="dialog-body">
      <div class="left">
        <div class="left-head">美的通讯录</div>
        <div class="left-tree">
          <el-tree
            lazy
            :props="defaultProps"
            @node-click="nodeClick"
            :render-content="treeContent"
            :load="loadNode"
          ></el-tree>
        </div>
      </div>
      <div class="mid">
        <div class="mid-head">
          <el-input v-model="searchPer" @change="search" placeholder="搜索员工" class="option-select">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search"
              style="cursor: pointer;"
            ></i>
          </el-input>
        </div>
        <div class="mid-content">
           <el-tooltip placement="right" class="box-person" v-for="(item,index) in personList" :key="index">
           <div slot="content">
            {{item.userName}}&nbsp;&nbsp;&nbsp;&nbsp;
            {{item.orgName}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.mainPostName}}
          </div>
          <div class="mid-person" >
            <el-checkbox v-model="item.isCheck" @change="checkPerson(item)"></el-checkbox>
            <svg v-if="item.sex === 1" class="icon" aria-hidden="true">
              <use xlink:href="#iconman" />
            </svg>
            <svg v-else class="icon" aria-hidden="true">
              <use xlink:href="#iconwoman" />
            </svg>
            <div class="name">{{item.userName}}</div>
            <span class="name-tip">{{item.positionName}}</span>
          </div>
          </el-tooltip>
        </div>
      </div>
      <div class="right">
        <div class="checked-list-title">
          <span class="checked-num">
            已选
            <i>&nbsp;{{personNum}}&nbsp;</i>
          </span>
        </div>
        <div class="right-content">
          <div v-for="(item,index) in seletPerson" :key="index" class="select-line">
            <div class="line-content">
              <div class="person-sex">
                <!-- <svg v-if="item.sex === 1" class="icon" aria-hidden="true">
                  <use xlink:href="#iconman" />
                </svg> -->
                <span class="iconfont iconwoman icon-color"></span>
                <!-- <svg v-else class="icon" aria-hidden="true">
                  <use xlink:href="#iconwoman" />
                </svg> -->
                <span class="right-name">{{item.userName}}</span>
              </div>
              <div class="person-del" @click="del(item,index)">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="modalClose">取 消</el-button>
      <el-button type="primary" @click="closePerDialog">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { organizations, searchUser } from './org';
import { dictWithUrl } from '@/components/otpPanel/api';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        isMulti: {
            type: Boolean,
            default: true
        },
        tableData: {
            type: Array
        }
    },
    data() {
        return {
            imgUrl: require('@/components/lots/Dialog/img/zuzhi.png'),
            orgShow: false,
            personNum: 0,
            searchPer: '',
            closeTable: [],
            personList: [],
            seletPerson: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            form: { selectTeam: '' },
            rules: {
                selectTeam: [{ required: true, message: ' ', trigger: 'blur' }]
            },
            personOptions: [] // 数字字典
        };
    },
    computed: { // 获取vuex
        loginState: function() {
            return this.$store.state.bidData;
        }
    },
    mounted() {
        this.closeTable = JSON.parse(JSON.stringify(this.tableData));// 防止删增成员没点保存
        this.GROUP_CLASSIFICATION();
        this.init();
    },
    methods: {
        async GROUP_CLASSIFICATION() {
            const res = await dictWithUrl('BID_GROUP_CLASSIFICATION');
            for (const key in res.data.BID_GROUP_CLASSIFICATION) {
                if (key) {
                    const obj = {};
                    obj.value = key;
                    obj.label = res.data.BID_GROUP_CLASSIFICATION[key];
                    if (!this.loginState.isShowTab && this.loginState.syntheticalScore === 'N' && (obj.value === '30' || obj.value === '40')) {
                        obj.disabled = true;
                    }
                    this.personOptions.push(obj);
                }
            }
        },
        modalClose() {
            this.$emit('update:visible', false); // 直接修改父组件的属性
        },
        // 确认按钮
        closePerDialog() {
          if(!this.isMulti && this.seletPerson.length > 1){
            this.$message.warning('招标小组组长只允许新增一个成员')
            return
          }
          this.$emit(
                        'add-perDetermine',
                        JSON.parse(JSON.stringify(this.seletPerson)),
                        this.form.selectTeam,
                        false
                    );
        },

        // 单个删除
        del(item, index) {
            this.seletPerson.splice(index, 1);
            this.personNum = this.seletPerson.length;
            const arr = this.personList;
            this.personList = [];
            arr.forEach(item => {
                const a = this.seletPerson.filter(e => e.userCode === item.userCode);
                if (a.length > 0) {
                    item.isCheck = true;
                } else {
                    item.isCheck = false;
                }
                this.personList.push(item);
            });
        },
        // 搜索
        search() {
            searchUser({ queryParam: this.searchPer }).then(res => {
                if (res && res.code === '0') {
                    this.personList = [];
                    const arr = res.data.list;
                    arr.forEach(item => {
                        const a = this.seletPerson.filter(
                            e => e.userCode === item.userCode
                        );
                        if (a.length > 0) {
                            item.isCheck = true;
                        } else {
                            item.isCheck = false;
                        }
                        this.personList.push(item);
                    });
                }
            });
        },
        loadNode(node, resolve) {
            if (node.level === 0) {
                organizations().then(res => {
                    if (res.data) {
                        return resolve(res.data);
                    }
                });
                return false;
            } else {
                organizations({ parentCode: node.data.code }).then(res => {
                    if (res.data) {
                        return resolve(res.data);
                    } else {
                        return resolve([]);
                    }
                });
            }
        },
        treeContent(h, { node, data, store }) {
            return (
                <span>
                    <img src={this.imgUrl} style="vertical-align: text-top;" />
                    <span style="margin-left:5px" class="showHighlight">
                        {node.label}
                    </span>
                </span>
            );
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        nodeClick(data, node, obj) {
            organizations({
                tenantFlag: 0,
                withUserFlag: 1,
                code: node.data.code
            }).then(res => {
                if (res && res.code === '0') {
                    this.personList = [];
                    const arr = res.data[0].users;
                    arr.forEach(item => {
                        const a = this.seletPerson.filter(
                            e => e.userCode === item.userCode
                        );
                        if (a.length > 0) {
                            item.isCheck = true;
                        } else {
                            item.isCheck = false;
                        }
                        this.personList.push(item);
                    });
                }
            });
        },
        async init() {
            this.seletPerson = this.closeTable;
            this.personNum = this.closeTable.length;
        },
        // 小组分类下拉框选择
        changeTeam(val) {
            this.form.selectTeam = val;
            const arr = this.personList;
            this.personList = [];
            const a = this.closeTable.filter(e => e.userType === val);
            this.seletPerson = a;
            arr.forEach(item => {
                const a = this.seletPerson.filter(e => e.userCode === item.userCode);
                if (a.length > 0) {
                    item.isCheck = true;
                } else {
                    item.isCheck = false;
                }
                this.personList.push(item);
            });
            this.personNum = this.seletPerson.length;
        },
        checkPerson(item) {
            if (item.isCheck) {
                const a = this.seletPerson.filter(e => {
                    return e.userCode !== item.userCode;
                });
                this.seletPerson = a;
                this.seletPerson.push(item);
            } else {
                const b = this.seletPerson.filter(e => {
                    return e.userCode !== item.userCode;
                });
                this.seletPerson = b;
            }
            this.personNum = this.seletPerson.length;
        }
    }
};
</script>
<style lang="less">
#org-group {
  .dialog-body {
    width: 100%;
    height: 445px;
    display: flex;
  }
  .left {
    width: 30%;
    height: 100%;
    border-right: 1px solid #e6e6e6;
    .left-head {
      background-color: #f2f2f2;
      height: 40px;
      line-height: 40px;
      color: #666666;
      font-size: 14px;
      padding-left: 15px;
    }
    .left-tree {
      height: 100%;
      overflow: auto;
    }
  }
  .mid {
    width: 40%;
    height: 100%;
    border-right: 1px solid #e6e6e6;
    .mid-head {
      height: 40px;
      display: flex;
      align-items: center;
      background-color: #f2f2f2;
      justify-content: flex-end;
      padding-right: 20px;
    }
    .mid-content {
      height: 100%;
      overflow: auto;
    }
    .el-checkbox {
      margin-left: 10px;
      margin-right: 15px;
    }
    .name {
      width: 60px;
      margin-left: 10px;
      margin-right: 10px;
    }
    .name-tip{color:#999999}
    .mid-person {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .icon {
        font-size: 14px;
        width: 16px;
        height: 16px;
      }
    }
    .mid-content .box-person:nth-child(even){
      background: #f9f9f9;
    }
    .box-person{
      height: 40px;
     display: flex;
     }
  }
  .right {
    width: 30%;
    height: 100%;
    .checked-list-select {
      display: flex;
      justify-content: center;
      height: 40px;
    }
    .checked-list-title {
      width: 100%;
      height: 40px;
      background-color: #f2f2f2;
      line-height: 38px;
      color: #666666;
      padding: 0 10px 0 20px;
      box-sizing: border-box;
    }
    .checked-num i {
      font-style: normal;
      color: #3ea4eb;
    }
    .clear-all {
      float: right;
      cursor: pointer;
    }
    .right-content {
      height: calc(100% - 70px);
      overflow: auto;
      .right-name{
        padding-left:10px
      }
    }
    .line-content {
      height: 40px;
      display: flex;
      align-items: center;
      .icon {
        font-size: 14px;
        width: 16px;
        height: 16px;
      }
      .person-sex {
        width: 80%;
        padding-left: 20px;
      }
      .person-del {
        width: 20%;
        text-align: right;
        cursor: pointer;
        .el-icon-close {
          padding-right: 10px;
        }
      }
    }
  }
  .option-select{width: 220px;}
   .icon-color{color: #58bc58;}
}
</style>